<template>
    <v-dialog
        v-model="deleteNoteDialog"
        hide-overlay
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-if="rowids"
                class="ma-1 text-subtitle-2 float-right"
                outlined
                light
                :disabled="rowids.length <= 0"
                v-bind="attrs"
                @click="openModel"
            >
                <v-icon>mdi-delete-outline</v-icon>
                Delete
            </v-btn>
            <v-icon
                v-if="rowid"
                class="mr-2"
                v-bind="attrs"
                @click="openModel"
            >
                mdi-delete-outline
            </v-icon>
        </template>
        <v-card>
            <v-card-title class="text-h5 lighten-2">
                <span>Delete</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div
                    v-if="rowid"
                    id="delete-note-container"
                >
                    Are you sure you want to delete this note 
                    form the note list?
                </div>
                <div
                    v-else
                    id="delete-note-container"
                >
                    Are you sure you want to delete selected notes 
                    form the note list?
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    outlined
                    light
                    @click="closedModel"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    @click="multipleDeleteNote"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    props: {
        rowids: {
            type: Array,
            required: false,
            default: () => [],
        },
        rowid: {
            type: String,
            required: false,
            default: '',
        }
    },
    data: () => ({
        deleteNoteDialog: false
    }),
    methods: {
        closedModel() {
            this.deleteNoteDialog = false;
        },
        openModel() {
            this.deleteNoteDialog = true;
        },
        async multipleDeleteNote() {
            if(this.rowid) {
                let request = {
                    oper: 'delete',
                    rowid: this.rowid,
                    __TIMESTAMP__: new Date().getTime()
                };
                let response = await webtmsBackend.addNote(request);
                if(response.result == 'OK') {
                    this.rowid = null;
                    this.$emit('load-ticket-details');
                    this.closedModel();
                }
            } else if(this.rowids.length) {
                this.rowids.map(async (item, index) => {
                    let request = {
                        oper: 'delete',
                        rowid: typeof(item) === 'string' ? item : item.rowid,
                        __TIMESTAMP__: new Date().getTime()
                    };
                    let response = await webtmsBackend.addNote(request);
                    if(response.result == 'OK') {
                        if(index + 1 === this.rowids.length) {
                            this.rowids = [];
                            this.$emit('load-ticket-details');
                            this.closedModel();
                        }
                    }
                });
            }
        }
    }
};
</script>
<style>
    #delete-note-container {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.0025em;
        color: #35383F;
        margin: 16px 0px;
    }
</style>